/* -------------------------------------------------------------------------
   TPS header, scrolled state. 2026-09-18

   Sets [data-tps-scrolled] on the header once the page has scrolled past the
   threshold. assets/tps-header.css does the rest.

   Two things worth knowing:
     1. The scroller on this theme is .page-wrapper, not the window. <html>
        and <body> are both overflow:hidden, so a window scroll listener
        never fires. The window is kept as a fallback in case that changes.
     2. Horizon already writes a data-scroll-direction attribute on the
        header, but it stays "none" here, so it cannot be used as a trigger.

   Reads are batched into a rAF so a fast scroll cannot thrash layout.
   ------------------------------------------------------------------------- */
(function () {
  var header = document.getElementById('header-component');
  if (!header) return;

  var THRESHOLD = 90;
  var scroller = document.querySelector('.page-wrapper');
  var usesWindow = !scroller || scroller.scrollHeight <= scroller.clientHeight;
  var target = usesWindow ? window : scroller;
  var ticking = false;

  function currentTop() {
    if (usesWindow) {
      return window.scrollY || document.documentElement.scrollTop || 0;
    }
    return scroller.scrollTop;
  }

  function apply() {
    ticking = false;
    var past = currentTop() > THRESHOLD;
    if (past === header.hasAttribute('data-tps-scrolled')) return;
    header.toggleAttribute('data-tps-scrolled', past);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  target.addEventListener('scroll', onScroll, { passive: true });
  apply();
})();
